import { useCallback } from 'react';

import { useApplicationBuildContext } from '@context/ApplicationBuildContext';
import { PAGES } from '@services/routingService';
import { EPage } from '@types';
import { formatUrl } from '@utils/text';

import { trackOrderAsLastTimePageViewEvent } from '../../events';

export const useTrackOrderAsLastTimePageViewEvent = () => {
  const {
    settings: { websiteHostAddress },
  } = useApplicationBuildContext();

  // referrer for Oalt will be always cart page, because there is no other way how customer can get to Oalt
  const previousPageUrl = formatUrl({ urlBase: websiteHostAddress, path: PAGES[EPage.CART].internal! });

  return useCallback(() => {
    trackOrderAsLastTimePageViewEvent(previousPageUrl);
  }, [previousPageUrl]);
};
